import isHalfTopping from './isHalfTopping';

export default isHalfTopping;
